module.exports = __webpack_public_path__ + "static/media/spaghetti.df67b248.jpg";